var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLounge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 77,
    viewBox: "0 0 79 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9483 57.9148V76.3242H54.1611V59.9819H30.8661V76.3242H25.0789V59.9819H11.5748V76.3242H5.78692V50.9069C5.73037 49.4543 6.29186 48.0447 7.33338 47.0268C8.3749 46.009 9.79955 45.4769 11.2564 45.5621H25.0788V30.1814H0V27.24C0 17.6241 5.14762 8.7378 13.5041 3.93019C21.8604 -0.87777 32.1559 -0.87777 40.5133 3.93019C48.8695 8.73814 54.0173 17.6242 54.0173 27.24V30.1814H30.8671V45.5621H59.9014L62.1197 40.9285L37.8027 40.8708V35.1034L65.0618 34.9303L73.82 17.4724L79 20.0489L59.9483 57.9148Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLounge);
export default __webpack_public_path__ + "static/media/lounge.c685404243c7a5afd8b2f1669f9670c3.svg";
export { ForwardRef as ReactComponent };